import { createSlice } from "@reduxjs/toolkit";

const themeMode = localStorage.getItem("mode");

const initialState = {
  mode: themeMode ? themeMode : "light",
  isChecked: themeMode === "light" || !themeMode ? false : true,
};

const modeSlice = createSlice({
  name: "modes",
  initialState,
  reducers: {
    changeMode: (state, action) => {
      if (action.payload === "light") {
        localStorage.setItem("mode", "dark");
        state.mode = "dark";
        state.isChecked = true;
      } else {
        localStorage.setItem("mode", "light");
        state.mode = "light";
        state.isChecked = false;
      }
    },
  },
});

export const { changeMode } = modeSlice.actions;
export default modeSlice.reducer;
